import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpService } from "../../../../core/shared/http.service";
import { SchemaModel } from "../interfaces/schema-model.interface";
import { SchemaRouteStationInfo } from "../interfaces/schema-route-station-info.interface";

@Injectable({
  providedIn: 'root'
})
export class SchemaService {
  constructor(private httpService: HttpService) { }

  public getSchemaData(groupId: number): Observable<SchemaModel> {
    return this.httpService.get<SchemaModel>('Schema/' + groupId);
  }

  /** Selbsttragende Anzeige-Sicht einer einzelnen Station, adressiert über die RouteStation-Guid. */
  public getSchemaDeviceInfo(routeStationId: string): Observable<SchemaRouteStationInfo> {
    return this.httpService.get<SchemaRouteStationInfo>('Schema/Device/' + routeStationId);
  }
}
